import React, { useState } from 'react';

import './main.css'
import Table from './Table.js';
import Genres from './Genres.js';
import TipMenu from './TipMenu.js';



export default function RemoteTabs(props) {
    const uid = props.uid
    const idx = props.idx
    const queued_idx = props.queued_idx

    const start = props.start
    const status = props.active
    const pax = props.passenger
    const pax_proximity = props.pax_proximity
    const driver_pax_proximity = props.driver_pax_proximity
    const queue_control = props.queue_control
    const vol_control = props.vol_control

    const pax_access = props.pax_access;
	const driver_access = props.driver_access
    const circle_delay = props.circle_delay

    const driver_tips = props.driver_tips
    const pax_sesh_id = props.pax_sesh_id

    const [activeTab, setActiveTab] = useState('queue');
    const [tipAnchor, setTipAnchor] = useState(null);

    const handleTabKey = event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 'queue' : event.key === 'End' ? 'history' : activeTab === 'queue' ? 'history' : 'queue';
        setActiveTab(next);
        document.getElementById(`${next}-tab`)?.focus();
    };

    const handleTipClick = (event) => {
        setTipAnchor(event.currentTarget);
    }

    return (pax_proximity || driver_pax_proximity)  ? (
        <main className="remote-content">
            {/* Dark pill tab bar */}
            <div className='tab-toolbar'><div className='dark-pill-tabs' role="tablist" aria-label="Music">
                <button
                    className={`dark-pill-tab ${activeTab === 'queue' ? 'active' : ''}`}
                    role="tab" tabIndex={activeTab === 'queue' ? 0 : -1} onKeyDown={handleTabKey} id="queue-tab" aria-selected={activeTab === 'queue'} aria-controls="queue-panel" onClick={() => setActiveTab('queue')}
                >
                    Queue
                </button>
                <button
                    className={`dark-pill-tab ${activeTab === 'history' ? 'active' : ''}`}
                    role="tab" tabIndex={activeTab === 'history' ? 0 : -1} onKeyDown={handleTabKey} id="history-tab" aria-selected={activeTab === 'history'} aria-controls="history-panel" onClick={() => setActiveTab('history')}
                >
                    History
                </button>
                </div><button
                    className='tip-action'
                    id="tip-tab-button"
                    aria-haspopup="menu"
                    aria-expanded={Boolean(tipAnchor)}
                    aria-controls={tipAnchor ? 'tip-popup-menu' : undefined}
                    onClick={handleTipClick}
                >
                    ♡ Tip driver
                </button>
            </div>

            {/* Queue Panel */}
            {(
                <div hidden={activeTab !== 'queue'} role="tabpanel" id="queue-panel" aria-labelledby="queue-tab">
                    <Genres live_pax={props.live_pax} uid={uid} pax_proximity={pax_proximity} driver_access={driver_access} pax_access={pax_access} passenger={pax} start={start} idx={idx} circle_delay={circle_delay} queue_control={queue_control} vol_control={vol_control} queued_idx={queued_idx}/>
                </div>
            )}

            {/* History Panel */}
            {activeTab === 'history' && (
                <div role="tabpanel" id="history-panel" aria-labelledby="history-tab"><div className="content-heading"><h2>Heard on this ride</h2><p>A good song is worth finding again.</p></div>
                    <Table uid={uid} active={status} pax_proximity={pax_proximity} driver_proximity={driver_pax_proximity} passenger={pax} start={start} idx={idx} queued_idx={queued_idx} geo_locked={false}/>
                </div>
            )}

            {/* Tip Menu - triggered from tab */}
            <TipMenu uid={uid} driver_tips={driver_tips} pax={pax} pax_sesh_id={pax_sesh_id} anchorEl={tipAnchor} onClose={() => setTipAnchor(null)}/>
        </main>
    ) : (
        <main className="remote-content">
            {/* Only history when geo-locked */}
            <div className='tab-toolbar'><div className='dark-pill-tabs' role="tablist" aria-label="Music">
                <button className='dark-pill-tab active'>
                    History
                </button>
            </div></div>
            <div>
                <Table uid={uid} active={status} pax_proximity={pax_proximity} driver_proximity={driver_pax_proximity} passenger={pax} start={start} idx={idx} queued_idx={queued_idx} geo_locked={true}/>
            </div>
        </main>
    );
}
